import { Site } from "../models/site";
import axiosConfig from "./axiosConfig";

const getSite = async (
  authToken: string,
  siteId: string,
  userOrgId?: string | null,
  testOrgId?: string | null
): Promise<Site> => {
  const params = new URLSearchParams();
  if (userOrgId) params.append("userOrgId", userOrgId);
  if (testOrgId) params.append("testOrgId", testOrgId);

  const url = `/site/${siteId}${params.size > 0 ? `?${params}` : ""}`;

  const { data } = await axiosConfig.get(url, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getSite;
